module.exports = __webpack_public_path__ + "static/media/ico-exames.eaf3c852.svg";